
export default function Logo() {
    const config = window.AppSettings?.theme?.headerLogo;

    if (config) {
        return (
            <img
                src={config.path}
                alt="Logo"
                style={{ height: config.height || 32, marginRight: 16 }}
            />
        );
    }

    return (
        <div style={{ color: '#ffffff', fontWeight: 'bold' }}>
            ECloudPacs {' © '} {new Date().getFullYear()}
        </div>
    )
}
